module.exports = __webpack_public_path__ + "media/images/amy-6ee044e53f052cf9d0d853fca0aa8618.png";